export default __webpack_public_path__ + "static/warehouse-a936bee6662b48da2fc859a706729fcd.png";